import { JSX } from 'react'

import { IconProps } from '../../icon'

const ChevronUp: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke ?? '#FF4821'}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M10.605 19.17L24.505 28.83L38.395 19.17'
      strokeLinecap='round'
      strokeMiterlimit='10'
      strokeWidth='2'
    />
  </svg>
)

export default ChevronUp
